<div class="title-container">
  <div class="title">{{ getTitle() | translate }}</div>
</div>
<div [hidden]="isLoading()">
  <mat-dialog-content>
    @if (steps.length > 1) {
      <mat-stepper
        #stepper
        [linear]="!this.knowledgeSource"
        [labelPosition]="'bottom'"
        (selectionChange)="stepChanged($event)"
      >
        <mat-step [stepControl]="form">
          <ng-template matStepLabel>{{ 'EDIT_KNOWLEDGE.ENTER_KNOWLEDGE' | translate }}</ng-template>
          <ng-template matStepContent>
            <ng-container *ngTemplateOutlet="customForm"></ng-container>
          </ng-template>
        </mat-step>
        @if (!excludeAddToAIStep) {
          <mat-step>
            <ng-template matStepLabel>{{ 'EDIT_KNOWLEDGE.ADD_TO_AI' | translate }}</ng-template>
            <ng-template matStepContent>
              <ai-knowledge-application-selector
                #applicationSelector
                [knowledgeSourceId]="knowledgeSource?.id"
                (createWidgetClicked)="createWebChatWidget()"
              ></ai-knowledge-application-selector>
            </ng-template>
          </mat-step>
        }
      </mat-stepper>
    } @else {
      <ng-container *ngTemplateOutlet="customForm"></ng-container>
    }

    <ng-template #customForm>
      <ng-container [formGroup]="form">
        <glxy-form-field [required]="true">
          <glxy-label>{{ 'EDIT_KNOWLEDGE.NAME' | translate }}</glxy-label>
          <input matInput formControlName="name" />
          @if (form.get('name')?.hasError('required') && form.get('name')?.dirty) {
            <glxy-error>
              {{ 'EDIT_KNOWLEDGE.REQUIRED_FIELD' | translate }}
            </glxy-error>
          }
        </glxy-form-field>
        <glxy-form-field [required]="true">
          <glxy-label>{{ 'EDIT_KNOWLEDGE.CUSTOM_DATA_CONFIG.CONTENT' | translate }}</glxy-label>
          <glxy-label-hint class="content-hint">{{
            'EDIT_KNOWLEDGE.CUSTOM_DATA_CONFIG.CONTENT_HINT' | translate
          }}</glxy-label-hint>
          <textarea class="content-input" matInput formControlName="content" rows="10"></textarea>
          @if (form.get('content')?.hasError('required') && form.get('content')?.dirty) {
            <glxy-error>
              {{ 'EDIT_KNOWLEDGE.REQUIRED_FIELD' | translate }}
            </glxy-error>
          }
        </glxy-form-field>
      </ng-container>
    </ng-template>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <div class="actions">
      @if (otherAIDisclaimer()) {
        <div class="used-with-other-ai">{{ otherAIDisclaimer() }}</div>
      }
      <div class="buttons">
        @if (showBack()) {
          <div class="card-actions__secondary">
            <button mat-stroked-button (click)="back()">{{ 'COMMON.BACK' | translate }}</button>
          </div>
        }

        <div class="card-actions__primary">
          <button mat-stroked-button (click)="close()">{{ 'COMMON.CLOSE' | translate }}</button>
          <button mat-flat-button color="primary" (click)="submit()">
            {{ getSubmitAction() | translate }}
          </button>
        </div>
      </div>
    </div>
  </mat-dialog-actions>
</div>

<glxy-loading-spinner *ngIf="isLoading()"></glxy-loading-spinner>
